import { create } from 'zustand';

interface ITab2ProductsAccordionState {
  expandedAccordions: Record<string, boolean>;
  setAccordionExpanded: (sku: string, isExpanded: boolean) => void;
  clearAccordionState: () => void;
}

/**
 * Store global para manejar el estado de los acordeones en Tab2Products
 * Permite mantener los acordeones abiertos después de guardar o reservar stock
 */
const useTab2ProductsAccordionState = create<ITab2ProductsAccordionState>(set => ({
  expandedAccordions: {},
  setAccordionExpanded: (sku: string, isExpanded: boolean) =>
    set(state => ({
      expandedAccordions: {
        ...state.expandedAccordions,
        [sku]: isExpanded
      }
    })),
  clearAccordionState: () => set({ expandedAccordions: {} })
}));

export default useTab2ProductsAccordionState;
